import { BaseModel } from "sjs-base-model";
import DocumentsActionModel from "./DocumentActionModel";

export default class DocumentsSignStatusModel extends BaseModel {
    public readonly idProcess: string = "";
    public readonly insertDate: string = "";
    public readonly signDate: string = "";
    public readonly cancelDate: string = "";
    public readonly state: string = "";
    public readonly stateId: number = -2;
    public readonly insertUserCode: number = 0;
    public readonly cancelUserCode: number = 0;
    public readonly documents: DocumentsActionModel[] = [];

    constructor(data: Partial<DocumentsSignStatusModel>) {
        super();

        this.update(data);
    }
}
